// extracted by mini-css-extract-plugin
module.exports = {"header":"Collapsible_header__3qtrF","headerHidden":"Collapsible_headerHidden__1G9ks","hidden":"Collapsible_hidden__APiur"};